<template>
  <loading-spinner v-if="isLoading" small />
  <histogram-sparkline
    v-else-if="dataCategory === 'Continuous'"
    :key="'hsl-' + datasetId + '-' + type + '-' + scaleId"
    :data="data"
  />
  <column-chart v-else :data="data" />
</template>

<script>
import { mapActions } from 'vuex';
import { actions } from '@/store/modules/datasetManager/types';
import { histogram, extent } from 'd3';
import HistogramSparkline from '@/components/charts/HistogramSparkline.vue';
import ColumnChart from '@/components/charts/ColumnChart.vue';

const flattenGroupCounts = data => {
  let res = [];
  data.forEach(d => {
    for (let i = 0; i < d.count; i++) {
      res.push(+d['value']);
    }
  });
  return res;
};

export default {
  components: {
    HistogramSparkline,
    ColumnChart,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    scaleId: {
      type: Number,
      required: true,
    },
    datasetId: {
      type: Number,
      required: true,
    },
    dataCategory: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
      data: [],
    };
  },
  async created() {
    this.isLoading = true;
    const datasetId = this.datasetId;
    const varId = this.scaleId;
    if (this.type === 'observation') {
      this.data = await this.fetchObsVarCounts({ datasetId, varId });
    } else {
      this.data = await this.fetchSubjVarCounts({ datasetId, varId });
    }

    // Bin data for histogram
    if (this.dataCategory == 'Continuous') {
      const fcounts = flattenGroupCounts(this.data);
      const ex = extent(fcounts);
      const bin_fn = histogram()
        .value(d => d)
        .domain(ex);
      this.data = bin_fn(fcounts);
    }

    this.isLoading = false;
  },
  methods: {
    ...mapActions('datasetManager', {
      fetchObsVarCounts: actions.FETCH_OBS_VAR_COUNTS,
      fetchSubjVarCounts: actions.FETCH_SUBJ_VAR_COUNTS,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
